import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useNetworkDownline = (id) => useQuery({ queryKey: [`network-downline`, id], queryFn: async () => {
    if(!id) return {}
    const callback = await API.get(`/network/${id}`)
    return callback?.data
}, staleTime: 1000 * 60 * 60 * 24, gcTime: 1000 * 60 * 60 * 24 * 7 })

export default useNetworkDownline